export default (date) =>
	`Ваша запись на <span class="modal__time--green" data-rm-selected-date>${date}</span>
	г.`;
